<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <g fill="none" fill-rule="evenodd" v-if="active">
      <circle
        cx="20"
        cy="20"
        r="19.389"
        stroke="#122033"
        stroke-width="1.222"
      />
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M23.313 18.269h4.334L25.33 15.95l.534-.534 3.209 3.208-3.209 3.208-.534-.534 2.317-2.318h-4.314V30.39h-6.416V18.98h-4.314L14.92 21.3l-.534.534-3.209-3.208 3.209-3.208.534.534-2.317 2.318h4.334a3.21 3.21 0 0 1 2.832-2.833v-4.333L17.45 13.42l-.534-.534 3.208-3.209 3.208 3.209-.534.534-2.318-2.317v4.333a3.215 3.215 0 0 1 2.832 2.833zm-3.188-2.14a2.498 2.498 0 0 0-2.495 2.501v11.046h4.99V18.63a2.5 2.5 0 0 0-2.495-2.5zm0 .714c.991 0 1.782.8 1.782 1.789v2.488h-3.564v-2.488c0-.985.798-1.79 1.782-1.79zm0 .713c-.59 0-1.07.483-1.07 1.07v1.781h2.14v-1.781c0-.591-.475-1.07-1.07-1.07zm-1.782 5.703v.713h3.564v-.713h-3.564zm0 1.426v.713h3.564v-.713h-3.564z"
      />
    </g>
    <g fill="none" fill-rule="evenodd" v-else>
      <circle cx="20" cy="20" r="20" fill="#ADB2B8" opacity=".3" />
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M23.313 18.269h4.334L25.33 15.95l.534-.534 3.209 3.208-3.209 3.208-.534-.534 2.317-2.318h-4.314V30.39h-6.416V18.98h-4.314L14.92 21.3l-.534.534-3.209-3.208 3.209-3.208.534.534-2.317 2.318h4.334a3.21 3.21 0 0 1 2.832-2.833v-4.333L17.45 13.42l-.534-.534 3.208-3.209 3.208 3.209-.534.534-2.318-2.317v4.333a3.215 3.215 0 0 1 2.832 2.833zm-3.188-2.14a2.498 2.498 0 0 0-2.495 2.501v11.046h4.99V18.63a2.5 2.5 0 0 0-2.495-2.5zm0 .714c.991 0 1.782.8 1.782 1.789v2.488h-3.564v-2.488c0-.985.798-1.79 1.782-1.79zm0 .713c-.59 0-1.07.483-1.07 1.07v1.781h2.14v-1.781c0-.591-.475-1.07-1.07-1.07zm-1.782 5.703v.713h3.564v-.713h-3.564zm0 1.426v.713h3.564v-.713h-3.564z"
        opacity=".4"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
};
</script>

<style></style>
